import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { isNil } from 'lodash';
import type { OrderActionEnum } from 'models/enums/orderActionEnum';
import type { FC } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LegendActionsList: FC<{
  onChange?: (item: LegendItem, checked: boolean) => void;
  items: LegendItem[];
}> = ({ onChange, items }) => (
  <Stack direction={'column'}>
    {items.map((item) => (
      <FormControlLabel
        key={item.action}
        label={
          <Stack direction={'row'} spacing={0.5} alignItems={'center'}>
            <Box
              /* cspell:disable-next-line */
              className='fc-daygrid-event-dot'
              style={{ borderColor: item.color, borderWidth: 6, borderRadius: 6 }}
            />
            <div>{item.title}</div>
          </Stack>
        }
        control={
          <Checkbox
            checked={item.selected}
            onChange={(_, val) => {
              onChange?.(item, val);
            }}
          />
        }
      />
    ))}
  </Stack>
);

const Legend: FC<LegendProps> = ({ items, onChange, width, compact = false }) => {
  const handleChange = (item: LegendItem, checked: boolean): void => {
    item.selected = checked;

    !isNil(onChange) && onChange([...items]);
  };

  if (compact) {
    return (
      <Accordion disableGutters>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel2-content'
          id='panel2-header'>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography component='span' fontWeight='medium'>
              Этапы
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <LegendActionsList onChange={handleChange} items={items} />
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Paper
      sx={{
        mr: 2,
        p: 2,
        display: { xs: 'none', md: 'block' },
        '& .MuiDrawer-paper': { boxSizing: 'border-box', width },
      }}>
      <Typography variant='h6'>Этапы</Typography>
      <LegendActionsList onChange={handleChange} items={items} />
    </Paper>
  );
};

export interface LegendItem {
  title: string;
  color: string;
  action: OrderActionEnum;
  selected: boolean;
}

export interface LegendProps {
  onChange?: (items: LegendItem[]) => void;
  items: LegendItem[];
  compact?: boolean;
  width?: number;
}

export default Legend;
